import { render } from "./UploadProgress.vue?vue&type=template&id=20ac34b4&scoped=true"
import script from "./UploadProgress.vue?vue&type=script&lang=js"
export * from "./UploadProgress.vue?vue&type=script&lang=js"

import "./UploadProgress.vue?vue&type=style&index=0&id=20ac34b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ac34b4"]])

export default __exports__